import { SpaceType } from "src/app/_types/space-type";

export class PaginationClientSideOptions {
  overrideCountTranslation?: string;
  mainStyle?: string;
  styleClasses?: string[] = ["content-table"];
  routerLinkBase?: string;
  gridColumnsCount?: number = 12;
  headerAddLink?: string;
  headerEmitClick?: boolean;
  permissionEdit?: boolean = true;
  hideMobileHeader?: boolean = false;
  mobileViewBreakPoint?: number = 992;
  removeElementAction?: (id: number) => Promise<void> = null;
  actionButton?: string = "";
  actionButtonDisabled?: boolean = false;
  headerAddRemoveColSize?: number = 1;
  subheaderText?: string;
  subheaderCssClass?: string;
  noResultsText?: string;
  addButtonText?: string = "ADD";
  permissionAdd?: string;
  groupDateKey?: string;
  noProblemDateKeys?: string[];
  customData?: string;
  showLoader?: boolean;
  hideNoResultInfo?: boolean = false;
  headerStickyPosition?: string | number; //jeżeli wpiszemy wartość "disabled", nagłówek nie będzie sticky
  wideMobileAddButtonText?: string;
  noResultsAddLink?: string;
  mobileFilterButton?: boolean = false;
  spaceType?: SpaceType;
  hideMobileCounter?: boolean = false;
  permissionSpaceAdd?: boolean = false;
  withAssignment?: boolean = true;
}
